var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaptureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mode-portrait_2_",
    "data-name": "mode-portrait (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.852,
    height: 71.852,
    viewBox: "0 0 71.852 71.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_69834",
    "data-name": "Path 69834",
    d: "M36.957,16a2.994,2.994,0,0,0-2.994,2.994v5.988a8.981,8.981,0,0,1-8.981,8.981H18.994a2.994,2.994,0,0,0,0,5.988h5.988A14.987,14.987,0,0,0,39.951,24.981V18.994A2.994,2.994,0,0,0,36.957,16Z",
    transform: "translate(31.901 31.901)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69835",
    "data-name": "Path 69835",
    d: "M2.994,23.951a2.994,2.994,0,0,0,2.994-2.994V14.969a8.981,8.981,0,0,1,8.981-8.981h5.988a2.994,2.994,0,1,0,0-5.988H14.969A14.987,14.987,0,0,0,0,14.969v5.988a2.994,2.994,0,0,0,2.994,2.994Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69836",
    "data-name": "Path 69836",
    d: "M20.957,33.963H14.969a8.981,8.981,0,0,1-8.981-8.981V18.994a2.994,2.994,0,0,0-5.988,0v5.988A14.987,14.987,0,0,0,14.969,39.951h5.988a2.994,2.994,0,0,0,0-5.988Z",
    transform: "translate(0 31.901)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69837",
    "data-name": "Path 69837",
    d: "M24.981,0H18.994a2.994,2.994,0,0,0,0,5.988h5.988a8.981,8.981,0,0,1,8.981,8.981v5.988a2.994,2.994,0,1,0,5.988,0V14.969A14.987,14.987,0,0,0,24.981,0Z",
    transform: "translate(31.901)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9622",
    "data-name": "Ellipse 9622",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(24 8.852)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69838",
    "data-name": "Path 69838",
    d: "M22.963,13A17.981,17.981,0,0,0,5,30.963a2.994,2.994,0,0,0,2.994,2.994H43.92a2.994,2.994,0,0,0,2.994-2.994A17.981,17.981,0,0,0,28.951,13Z",
    transform: "translate(9.969 25.92)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureIcon);
export default __webpack_public_path__ + "static/media/captureIcon.9448142a4e8b045114d4317eb9899724.svg";
export { ForwardRef as ReactComponent };